import SettingsGearshapeFill from './SettingsGearshapeFill';

export default SettingsGearshapeFill;
